import { useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { Card } from '../../design-system/components/Card';
import { Spinner } from '../../design-system/components/Spinner';
import { Tabs } from '../../design-system/components/Tabs';
import { EmptyState } from '../../shared/components/EmptyState';
import { ErrorState } from '../../shared/components/ErrorState';
import { ConsentBanner } from './components/ConsentBanner';
import { ReadOnlyInsights } from './components/ReadOnlyInsights';
import { ReadOnlySummary } from './components/ReadOnlySummary';
import { ReadOnlyTranscript } from './components/ReadOnlyTranscript';
import { useMeetingDetail } from './hooks';

export function MeetingDetailView() {
  const { meetingId } = useParams();
  const [searchParams] = useSearchParams();
  const anchorSegmentId = searchParams.get('segment');
  const [activeTab, setActiveTab] = useState<string>(
    anchorSegmentId !== null ? 'transcript' : 'resumo',
  );

  const query = useMeetingDetail(meetingId);

  if (meetingId === undefined) {
    return <EmptyState title="Reunião inválida" />;
  }
  if (query.isPending) {
    return (
      <div className="center full-height">
        <Spinner label="Carregando reunião" />
      </div>
    );
  }
  if (query.isError) {
    return (
      <ErrorState
        error={query.error}
        onRetry={() => query.refetch()}
        title="Não foi possível carregar a reunião"
      />
    );
  }

  const meeting = query.data;

  return (
    <div className="dash-section">
      <div className="dash-section__header">
        <div>
          <Link to="/" className="muted">
            ← Voltar
          </Link>
          <h1 className="dash-section__title">{meeting.title ?? 'Reunião sem título'}</h1>
          <p className="muted">
            {meeting.lead_company ?? meeting.lead_name ?? 'Sem lead associado'}
          </p>
        </div>
      </div>

      <ConsentBanner meetingId={meetingId} />

      <Card>
        <Tabs
          items={[
            {
              id: 'resumo',
              label: 'Resumo',
              content: <ReadOnlySummary summary={meeting.summary} />,
            },
            {
              id: 'insights',
              label: 'Insights',
              content: <ReadOnlyInsights insights={meeting.insights} />,
            },
            {
              id: 'transcript',
              label: 'Transcrição',
              content: (
                <ReadOnlyTranscript
                  segments={meeting.transcript}
                  anchorSegmentId={anchorSegmentId}
                />
              ),
            },
          ]}
          value={activeTab}
          onChange={setActiveTab}
        />
      </Card>
    </div>
  );
}
